import { Component, OnInit, AfterViewInit } from '@angular/core';
import { CpmService } from '../../service/cpm.service';
import { environment } from '../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { ExportExcelService } from 'app/service/export-excel.service';
@Component({
  selector: 'app-market-cap-rank-pe',
  templateUrl: './market-cap-rank-pe.component.html',
  styleUrls: ['./market-cap-rank-pe.component.scss']
})
export class MarketCapRankPeComponent implements OnInit, AfterViewInit {
  dtTrigger: Subject<any> = new Subject();
  marketCapTableOptions: DataTables.Settings = {};
  peTableOptions: DataTables.Settings = {};
  countryList = [];
  marketCapData = [];
  totalList = [];
  totalPEList = [];
  peList = [];
  otherMarketCapList = [];
  otherPEList = [];
  asOfDate;
  getPrint

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private excelService: ExportExcelService,
    private cpmService: CpmService
  ) { }

  ngOnInit() {
    const { print } = this.activatedRoute.snapshot.data
    this.getPrint = print;
    this.loadData();
    this.marketCapTableOptions = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false
    };
    this.peTableOptions = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false,
      columnDefs: [{ targets: [0, 1, 2, 3, 4, 5, 6, 7], orderable: false }]
    };
  }

  excel() {
    this.excelService.exportMarketCapPERank(
      this.countryList,
      this.marketCapData,
      this.otherMarketCapList,
      this.totalList,
      this.peList,
      this.otherPEList,
      this.totalPEList
    );
  }

  async mail() {
    const filename = await this.cpmService.saveMarketCapPeRankPdfFile();
    const downloadUrl = encodeURIComponent(
      `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
    );
    this.mailToUrl(
      'ASEAN exchanges: Market cap (mil.USD) and PE ratio',
      downloadUrl
    );
  }

  print() {
    this.router.navigate(['marketCapPeRank/']);
  }

  mailToUrl(subject, url) {
    window.location.href = `mailto:?subject=${subject}&body=${url}`;
  }

  pdf() {
    const service = this.cpmService;
    service.downloadFile(`${environment.cpmBaseUrl}/pdf/marketCapPeRank`);
  }

  async loadData() {
    await this.cpmService.getExchangeStatisticByIndustry().then(obj => {
      this.asOfDate = obj.asOfDate;
      this.mapExchangeList(obj.exchangeStatistic);
    });
    this.dtTrigger.next();
  }

  adjustPEFormat(value) {
    if (value < 0) {
      return 'N/A';
    } else {
      return value.toFixed(2);
    }
  }

  mapExchangeList(exchangeList) {
    const rankList = [];
    const industryList = [];
    let maxLength = 0;
    for (let i = 0; i < exchangeList.length; i++) {
      this.countryList.push(exchangeList[i].country);
      this.totalList.push(exchangeList[i].marketCap);
      this.totalPEList.push(this.adjustPEFormat(exchangeList[i].pe));
      if (maxLength < exchangeList[i].industry.length) {
        maxLength = exchangeList[i].industry.length;
      }
      industryList.push(
        exchangeList[i].industry.sort((n1, n2) =>
          n1.industryName.localeCompare(n2.industryName)
        )
      );
    }
    let totalOfTotal = 0;
    for (let i = 0; i < maxLength; i++) {
      if (industryList[0][i].industryName === 'N/A') {
        this.otherMarketCapList.push(
          industryList[0][i].marketCap
        );
        this.otherMarketCapList.push(
          industryList[1][i].marketCap
        );
        this.otherMarketCapList.push(
          industryList[2][i].marketCap
        );
        this.otherMarketCapList.push(
          industryList[3][i].marketCap
        );
        this.otherMarketCapList.push(
          industryList[4][i].marketCap
        );
        this.otherMarketCapList.push(
          industryList[5][i].marketCap
        );
        const total =
          industryList[0][i].marketCap +
          industryList[1][i].marketCap +
          industryList[2][i].marketCap +
          industryList[3][i].marketCap +
          industryList[4][i].marketCap +
          industryList[5][i].marketCap;
        this.otherMarketCapList.push(total);
        totalOfTotal += total;
        this.otherPEList.push(this.adjustPEFormat(industryList[0][i].pe));
        this.otherPEList.push(this.adjustPEFormat(industryList[1][i].pe));
        this.otherPEList.push(this.adjustPEFormat(industryList[2][i].pe));
        this.otherPEList.push(this.adjustPEFormat(industryList[3][i].pe));
        this.otherPEList.push(this.adjustPEFormat(industryList[4][i].pe));
        this.otherPEList.push(this.adjustPEFormat(industryList[5][i].pe));
      } else {
        const total =
          industryList[0][i].marketCap +
          industryList[1][i].marketCap +
          industryList[2][i].marketCap +
          industryList[3][i].marketCap +
          industryList[4][i].marketCap +
          industryList[5][i].marketCap;
        totalOfTotal += total;
        this.marketCapData.push({
          sector: industryList[0][i].industryName,
          indo: industryList[0][i].marketCap,
          ml: industryList[1][i].marketCap,
          ph: industryList[2][i].marketCap,
          sp: industryList[3][i].marketCap,
          th: industryList[4][i].marketCap,
          vn: industryList[5][i].marketCap,
          total: total,
          indoRank: i,
          mlRank: i,
          phRank: i,
          spRank: i,
          thRank: i,
          vnRank: i,
          totalRank: i
        });
        this.peList.push({
          sector: industryList[0][i].industryName,
          indo: this.adjustPEFormat(industryList[0][i].pe),
          ml: this.adjustPEFormat(industryList[1][i].pe),
          ph: this.adjustPEFormat(industryList[2][i].pe),
          sp: this.adjustPEFormat(industryList[3][i].pe),
          th: this.adjustPEFormat(industryList[4][i].pe),
          vn: this.adjustPEFormat(industryList[5][i].pe),
          total: null,
          indoRank: i,
          mlRank: i,
          phRank: i,
          spRank: i,
          thRank: i,
          vnRank: i,
          totalRank: i
        });
      }
    }
    this.totalList.push(totalOfTotal);
    this.marketCapData.sort((n1, n2) => n2.indo - n1.indo);
    for (let i = 0; i < this.marketCapData.length; i++) {
      this.marketCapData[i].indoRank = i;
    }
    this.marketCapData.sort((n1, n2) => n2.ml - n1.ml);
    for (let i = 0; i < this.marketCapData.length; i++) {
      this.marketCapData[i].mlRank = i;
    }
    this.marketCapData.sort((n1, n2) => n2.ph - n1.ph);
    for (let i = 0; i < this.marketCapData.length; i++) {
      this.marketCapData[i].phRank = i;
    }
    this.marketCapData.sort((n1, n2) => n2.sp - n1.sp);
    for (let i = 0; i < this.marketCapData.length; i++) {
      this.marketCapData[i].spRank = i;
    }
    this.marketCapData.sort((n1, n2) => n2.th - n1.th);
    for (let i = 0; i < this.marketCapData.length; i++) {
      this.marketCapData[i].thRank = i;
    }
    this.marketCapData.sort((n1, n2) => n2.vn - n1.vn);
    for (let i = 0; i < this.marketCapData.length; i++) {
      this.marketCapData[i].vnRank = i;
    }
    this.marketCapData.sort((n1, n2) => n2.total - n1.total);
    for (let i = 0; i < this.marketCapData.length; i++) {
      this.marketCapData[i].totalRank = i;
    }
    this.marketCapData.sort((n1, n2) => n1.sector.localeCompare(n2.sector));
    for (let i = 0; i < this.marketCapData.length; i++) {
      this.peList[i].indoRank = this.marketCapData[i].indoRank;
      this.peList[i].mlRank = this.marketCapData[i].mlRank;
      this.peList[i].phRank = this.marketCapData[i].phRank;
      this.peList[i].spRank = this.marketCapData[i].spRank;
      this.peList[i].thRank = this.marketCapData[i].thRank;
      this.peList[i].vnRank = this.marketCapData[i].vnRank;
      this.peList[i].totalRank = this.marketCapData[i].totalRank;
    }
  }

  autoSortPE() {
    const table = $('#marketCapTable').DataTable();
    const sortedTableData = table
      .column(0)
      .data()
      .toArray();
    this.peList = sortedTableData.map(x => {
      const industry = x.replace(/&amp;/g, '&');
      return this.peList.filter(pe => pe.sector === industry)[0];
    });
    table.draw();
  }

  autoSortMarketCap() {
    const table = $('#peTable').DataTable();
    const sortedTableData = table
      .column(0)
      .data()
      .toArray();
    this.marketCapData = sortedTableData.map(x => {
      const industry = x.replace(/&amp;/g, '&');
      return this.marketCapData.filter(pe => pe.sector === industry)[0];
    });
    table.draw();
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 2500);
    }
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/market-cap-rank-pe/market-cap-rank-pe.component.ts